import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classes from "./notificationBox.module.css";
import {
  FlagIconBlack,
  messageIconBlack,
  NotificationAnnouncementIcon,
  NotificationCancelIcon,
  NotificationStarIcon,
  NotificationCheckedIcon,
} from "../../constant/imagePath";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { Button } from "../Button/Button";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";

export const NotificationBox = ({ data, onClick1, onClick2, customStyle }) => {
  const [isMobile425, setIsMobile425] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile425, 425);
  }, []);

  const renderIcon =
    data?.type == "announcement"
      ? NotificationAnnouncementIcon
      : data?.type == "training-report"
      ? NotificationStarIcon
      : data?.type == "training-request"
      ? NotificationCheckedIcon
      : //  Checked Status Too
      data?.type == "profile-update"
      ? (data?.status == "approved" && NotificationCheckedIcon) ||
        (data?.status == "declined" && NotificationCancelIcon) ||
        (data?.status == "profile-banned" && NotificationAnnouncementIcon) ||
        (data?.status == "profile-unbanned" && NotificationAnnouncementIcon)
      : data?.type == "lesson-booked"
      ? NotificationCheckedIcon
      : data?.type == "lesson-cancelled"
      ? NotificationCancelIcon
      : data?.type == "payment-update" && NotificationCheckedIcon;

  // const renderIcon =
  //   type === "complete"
  //     ? NotificationStarIcon
  //     : type === "add-certificate"
  //     ? NotificationCancelIcon
  //     : type === "go-to-onboarding"
  //     ? NotificationCancelIcon
  //     : type === "profile-banned" || type === "profile-unbanned"
  //     ? NotificationAnnouncementIcon
  //     : type === "success"
  //     ? NotificationCheckedIcon
  //     : NotificationCancelIcon;

  return (
    <div
      className={`${[classes.container].join(" ")}`}
      style={{
        color: Colors.neutralShadesOfGainsboro,
        borderBottomColor: Colors.neutralShadesOfGainsboro,
        ...customStyle,
      }}
    >
      <div className={`${[classes.icon].join(" ")}`}>
        <img src={renderIcon} />
      </div>
      <div className={`${[classes.contentBox].join(" ")}`}>
        <div className={`${[classes.content].join(" ")}`}>
          <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
            <span
              style={{
                ...Fonts.h7,
                fontFamily: "inter-600",
                lineHeight: "24px",
              }}
            >
              {data?.title}:{" "}
            </span>
            {data?.description}
          </p>
          {/* Date, Time, Location,  */}
          {/*End Date, Time, Location,  */}
          {data?.createdAt && (
            <p
              className={classes.date}
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
            >
              {data?.createdAt}
            </p>
          )}
          <div className={`${[classes.mt16].join(" ")}`}>
            {data?.type == "announcement" && data?.status === "send-feedback" && (
              <Button
                size={"Medium"}
                label={"Send Feedback"}
                customStyle={{
                  width: "max-content",
                  height: "48px",
                  padding: "14px 24px",
                }}
                onClick={() => onClick1(data?.type, data?.status)}
              />
            )}
            {data?.type === "training-report" && (
              <div className={classes.btnsBox}>
                <Button
                  icon={FlagIconBlack}
                  size={"Medium"}
                  customStyle={{ marginRight: "8px" }}
                  onClick={() => onClick1(data?.type, "report")}
                />
                <Button
                  size={"Medium"}
                  label={"Leave review"}
                  customStyle={{
                    width: "max-content",
                    height: "48px",
                    padding: "14px 24px",
                  }}
                  onClick={() => onClick2(data?.type, "leave-review")}
                />
              </div>
            )}
            {data?.type === "training-request" &&
              data?.status == "cancel-lesson" && (
                <div className={classes.btnsBox}>
                  <Button
                    icon={messageIconBlack}
                    size={"Medium"}
                    customStyle={{ marginRight: "8px" }}
                    onClick={() => onClick1(data?.type, "chat")}
                  />
                  <Button
                    size={"Medium"}
                    label={"Cancel lesson"}
                    customStyle={{
                      width: "max-content",
                      height: "48px",
                      padding: "14px 24px",
                    }}
                    onClick={() => onClick2(data?.type, "cancel-lesson")}
                  />
                </div>
              )}
            {data?.type === "training-request" && data?.status == "pending" && (
              <div className={classes.btnsBox}>
                <Button
                  label={"Accept"}
                  size={"Medium"}
                  primary={true}
                  customStyle={{
                    marginRight: "8px",
                    width: "max-content",
                    padding: "14px 24px",
                    height: "48px",
                  }}
                  onClick={() => onClick1(data?.type, "accept")}
                />
                <Button
                  size={"Medium"}
                  label={"Decline"}
                  customStyle={{
                    width: "max-content",
                    height: "48px",
                    padding: "14px 24px",
                  }}
                  onClick={() => onClick2(data, "decline")}
                />
              </div>
            )}
            {data?.status === "add-certificate" && (
              <div
                className={`${[
                  classes.btnsBox,
                  isMobile425 && classes.btnsBreakIntoCol,
                ].join(" ")}`}
              >
                <Button
                  label={"Add certificate"}
                  size={"Medium"}
                  primary={true}
                  customStyle={{
                    marginRight: "8px",
                    padding: "14px 24px",
                    width: isMobile425 ? "100%" : "max-content",
                  }}
                  onClick={() => onClick1(data, "add-certificate")}
                />
                <Button
                  size={"Medium"}
                  label={"Contact us"}
                  customStyle={{
                    width: isMobile425 ? "100%" : "max-content",
                    height: "48px",
                    padding: "14px 24px",
                  }}
                  onClick={() => onClick2(data, "contact-us")}
                />
              </div>
            )}
            {data?.type === "profile-update" && data?.status == "declined" && (
              <div
                className={`${[
                  classes.btnsBox,
                  isMobile425 && classes.btnsBreakIntoCol,
                ].join(" ")}`}
              >
                <Button
                  label={"Go to onboarding"}
                  size={"Medium"}
                  primary={true}
                  customStyle={{
                    marginRight: "8px",
                    padding: "14px 24px",
                    width: isMobile425 ? "100%" : "max-content",
                  }}
                  onClick={() => onClick1(data, "go-to-onboarding")}
                />
                <Button
                  size={"Medium"}
                  label={"Contact us"}
                  customStyle={{
                    width: isMobile425 ? "100%" : "max-content",
                    height: "48px",
                    padding: "14px 24px",
                  }}
                  onClick={() => onClick2(data, "contact-us")}
                />
              </div>
            )}
            {data?.type === "profile-update" &&
              data?.status === "profile-banned" && (
                <Button
                  size={"Medium"}
                  label={"Contact us"}
                  customStyle={{
                    width: "max-content",
                    height: "48px",
                    padding: "14px 24px",
                  }}
                  onClick={() => onClick1(data, "contact-us")}
                />
              )}
          </div>
        </div>
        {!data?.isSeen && (
          <div className={`${[classes.dotBox].join(" ")}`}>
            <span
              className={`${[classes.dot].join(" ")}`}
              style={{ backgroundColor: Colors.mainShadeOfRed }}
            ></span>
          </div>
        )}
      </div>
    </div>
  );
};

NotificationBox.propType = {
  data: PropTypes.object,
};
NotificationBox.defaultProps = {
  data: {
    title: "Announcement",
    description: "Added new sports and the ability to complain about users.",
    status: "declined",
    statusText: "declined.",
    isSeen: true,
    type: "announcement",
  },

  //   title: PropTypes.string,
  //   text: PropTypes.string,
  //   btnText: PropTypes.string,
  //   onClick: PropTypes.func,
  //   isSeen: PropTypes.bool,
};
